import { MapsLayout } from '@ansyn/core';

export const layoutOptions: MapsLayout[] = [
	{ id: 'layout1', mapsCount: 1 },
	{ id: 'layout2', mapsCount: 2 },
	{ id: 'layout3', mapsCount: 2 },
	{ id: 'layout4', mapsCount: 3 },
	{ id: 'layout5', mapsCount: 3 },
	{ id: 'layout6', mapsCount: 4 }
];



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/status-bar/models/layout-options.model.ts